import app from 'Cloud/Application/app';
import cloudFileSystem from 'Cloud/Application/Upload/tools/cloud/cloudFileSystem';
import { bytesToNDigits } from 'lib/bytes';
import React from 'react';
import { SPACE_LIST } from 'reactApp/constants/spaceList';
import { IProps, UploadDialog } from 'reactApp/ui/UploadDialog/UploadDialog';
import { renderModalDialog } from 'reactApp/utils/createDialogToolkit';
import { noop } from 'reactApp/utils/helpers';

const UPLOAD_MODE = app.getParam('UPLOAD_MODE');

const allowMultiple = UPLOAD_MODE === 1;
let fileSizeLimit;
let showIncreaseLink;

export const renderUploadDialog = renderModalDialog(({ setInputs, ...rest }: IProps) => {
    if (app.user.isOverquota()) {
        return null;
    }

    if (!fileSizeLimit) {
        fileSizeLimit = bytesToNDigits(app.getParam('PUBLIC') ? cloudFileSystem.getPublicFileSizeLimit() : app.user.getFileSizeLimit(), 3)
            .value;
    }
    if (!showIncreaseLink) {
        showIncreaseLink =
            !app.user.isPaidUser() && !app.user.isB2BUserCorp() && app.user.getFileSizeLimit() !== SPACE_LIST.gb_32 && !app.isPublic();
    }

    const handleSetInputs = (data, onClose) => {
        app.upload.on('queue:start', () => {
            onClose();
        });

        return setInputs(data, noop);
    };

    return (
        <UploadDialog
            allowMultiple={allowMultiple}
            fileSizeLimit={fileSizeLimit}
            showIncreaseLink={showIncreaseLink}
            setInputs={handleSetInputs}
            {...rest}
        />
    );
}, 'UploadDialog');
